module.exports = __webpack_public_path__ + "4993f8897eb502da3b17cf7f18bfd1e8.svg";